import ReservationSlotWithToolTip from './ReservationSlotWithTooltip';

export default ReservationSlotWithToolTip;
